import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-inventory-configuration',
  templateUrl: './inventory-configuration.component.html',
  styleUrls: ['./inventory-configuration.component.scss']
})
export class InventoryConfigurationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
